<template>
    <div>
        <div class="content-box mr60">
            <el-form ref="form" label-width="120px" :model="formItem" :rules="rules" class="form-wrap">
                <el-form-item label="" prop="type">
                    <el-radio v-model="formItem.type" label="1">按工单，分尺寸下载：<br /><span :style="{lineHeight: '24px', paddingLeft: '24px'}">如：项目名称.zip/项目名称-素材类型-工单ID/尺寸/素材文件</span></el-radio>
                    <div :style="{padding: '5px'}"></div>
                    <el-radio v-model="formItem.type" label="2">按工单下载：<br /><span :style="{lineHeight: '24px', paddingLeft: '24px'}">如：项目名称.zip/项目名称-素材类型-工单ID/素材文件</span></el-radio>
                </el-form-item>
            </el-form>
        </div>
        <p class="dialog-footer tac mt20">
            <el-button type="default" @click="hideModal" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="submitModal" :loading="formLoading" class="action-btn ml20">提交</el-button>
        </p>
    </div>
</template>

<!-- 工单管理 批量下载弹框-->
<script>

import API from "@/api/workOrder/store.js"
import matomoFun from "@/utils/matomo.js";
export default {
    name: "storeDownLoadModal",
    props:['cbs', 'list'],
    data(){
        return {
            formLoading:false,
            formItem:{
                type:'1',
            },
            rules:{
                type: [
                    { required: true, message: '请选择', trigger: 'blur' },
                ],
            },
        }
    },
    mounted(){
    },
    methods:{
        submitModal(){
            this.$refs.form.validate((valid) => {
                if (valid) {
                    let res_list = this.list.map(item=>({material_id:item.download_id, source:item.source}))
                    this.fetchBatchDownLoad(res_list)
                } else {
                    return false;
                }
            });
        },
        hideModal(){
            matomoFun.trackEvent('素材库', '点击', '批量下载素材(取消)')
            this.$emit('close');
        },
        //批量下载
        fetchBatchDownLoad(material) {
            let obj_params = {type: this.formItem.type, material:material}
            if(this.formItem.type == '1'){
                matomoFun.trackEvent('素材库', '点击', '批量下载素材(按工单分尺寸下载提交)')
            }else{
                matomoFun.trackEvent('素材库', '点击', '批量下载素材(按工单下载提交)')
            }
            API.postWorkOrderDownLoad(obj_params).then(res=>{
                this.$message.success(res.info)
                this.cbs.onSubmit()
            },err=>{
                this.$message.error(err.info)
            })
        },
    }
}
</script>

<style scoped>

</style>
